<template>
    <div>
        <div class="row pt-2" :class="{'bg-light-light': key % 2 == 0}" v-for="(item, key) in items" :key="key">
            <label class="label label-primary">{{ key+1 }}</label>
            <br/>
            <div class="col-md-12">
                <div class="row">
                    <div class="form-group col-md-7">
                        <label>Nama Bagian *</label>
                        <input :name="`name[${key}]`" class="form-control" placeholder="Eg: Indikator Kinerja Keuangan" v-model="item.name" />
                    </div>
                    <div class="form-group col-md-3">
                        <label>Bobot Bagian *</label>
                        <div class="input-group">
                            <input type="number" :name="`score[${key}]`" class="form-control" placeholder="Eg: 30" v-model="item.score" />
                            <div class="input-group-append"><span class="input-group-text">%</span></div>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Urutan Form</label>
                        <input :name="`order[${key}]`" class="form-control" placeholder="Eg: 1 - 10" v-model="item.order" />
                    </div>
                </div>
            </div>
            <div class="col-md-12 pb-2" v-for="(detail, detailKey) in item.template_report_blu_details" :key="detailKey">
                <div class="card">
                    <div class="card-body p-4">
                        <label class="label label-primary">{{key+1}}.{{ detailKey+1 }}</label>
                        <br/>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label>Nama Sub Bagian *</label>
                                <select :id="`target_indicator_id_${key}_${detailKey}`" :name="`target_indicator_id[${key}][${detailKey}]`" class="form-control target-indicator" style="width:100%" v-model="detail.target_indicator_id" v-select="detail.target_indicator_id">
                                </select>
                                <span class="form-text text-muted">Data terdapat pada indikator sasaran</span>
                            </div>
                            <div class="form-group col-md-2">
                                <label>Urutan Sub Form</label>
                                <input :name="`order[${key}]`" class="form-control" placeholder="Eg: 1 - 10" v-model="detail.order" />
                            </div>
                            <div class="col-md-4 d-flex justify-content-end mt-10">
                                <button @click="removePart(key, detailKey)" type="button" class="btn btn-light-danger btn-sm btn-icon"><i class="la la-times"></i></button>
                            </div>
                        </div>
                        <hr />
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col" class="width-50">#</th>
                                        <th scope="col">Unit - Indikator</th>
                                        <th scope="col" class="width-150">Bobot</th>
                                        <th scope="col" class="width-150">Rumus</th>
                                        <th scope="col" class="width-100">Urutan Form</th>
                                        <th scope="col">Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(formula, formulaKey) in detail.details" :key="formulaKey">
                                        <td>{{ formulaKey+1 }}</td>
                                        <td>
                                            <select
                                                :id="`template_form_data_detail_id_${key}_${detailKey}_${formulaKey}`"
                                                :name="`template_form_data_detail_id[${key}][${detailKey}][${formulaKey}]`"
                                                class="form-control indicator" style="width:100%"
                                                v-model="formula.template_form_data_detail_id"
                                                @change="onSelectIndicator(key, detailKey, formulaKey, formula.template_form_data_detail_id)"
                                                v-select="formula.template_form_data_detail_id">
                                            </select>
                                            <span class="form-text text-muted">Data indikator dikelompokan berdasarkan template pertahun</span>
                                        </td>
                                        <td>
                                            <div class="input-group">
                                                <input type="number" :name="`formula_score[${key}][${detailKey}][${formulaKey}]`" class="form-control" placeholder="Eg: 30" v-model="formula.score" />
                                                <div class="input-group-append"><span class="input-group-text">%</span></div>
                                            </div>
                                        </td>
                                        <td>
                                            <input :name="`result_value_formula[${key}][${detailKey}][${formulaKey}]`" class="form-control" placeholder="Eg: [A]/[B]*100" v-model="formula.result_value_formula" />
                                            <template v-for="(data, i) in formula.report_indicator_labels">
                                                <span class="form-text text-muted" :key="i">[{{ alphabet(i) }}]: {{ data.name }}</span>
                                            </template>
                                        </td>
                                        <td>
                                            <input :name="`order[${key}][${detailKey}][${formulaKey}]`" class="form-control" placeholder="Eg: 1 - 10" v-model="formula.order" />
                                        </td>
                                        <td>
                                            <button @click="removePartDetail(key, detailKey, formulaKey)" type="button" class="btn btn-light-danger btn-sm btn-icon"><i class="la la-times"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="5" class="text-right">
                                            <button type="button" @click="addNewPartDetail(key, detailKey)" class="btn btn-warning"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Detail</button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 p-4 d-flex justify-content-center">
                <button type="button" @click="addNewPart(key)" class="btn btn-info"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Sub Bagian</button>
            </div>
        </div>
        <div class="pt-4">
            <button type="button" @click="addNew()" class="btn btn-success"><i class="la la-plus"></i>&nbsp;&nbsp;Tambah Bagian</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TemplateReportBluForm',
        props: {
            save: Number,
            year: [String, Number],
            initialItems: Array
        },
        computed: {
        },
        data() {
            return {
                items: [],
            }
        },
        watch: {
            save(val) {
                this.$emit('items', this.items)
            }
        },
        mounted() {
            if(this.initialItems) {
                this.items = this.initialItems
                setTimeout(() => {
                    this.loadTargetIndicators()
                    this.loadIndicators()
                    this.items.map((item, key) => {
                        item.template_report_blu_details.map((detail, detailKey) => {
                            $(`#target_indicator_id_${key}_${detailKey}`)
                                .empty()
                                .append(`<option value="${detail.target_indicator_id}">${detail.target_indicator.name}</option>`)
                                .val(detail.target_indicator_id)
                                .trigger('change')
                            detail.details.map((formula, formulaKey) => {
                                $(`#template_form_data_detail_id_${key}_${detailKey}_${formulaKey}`)
                                    .empty()
                                    .append(`<option value="${formula.template_form_data_detail_id}">${formula.template_form_data_detail.unit_with_indicator_name}</option>`)
                                    .val(formula.template_form_data_detail_id)
                                    .trigger('change')
                            })
                        })
                    })
                }, 300)
            }
        },
        methods: {
            removePart(key, detailKey) {
                this.items[key].template_report_blu_details.splice(detailKey, 1)
            },
            removePartDetail(key, detailKey, formulaKey) {
                this.items[key].template_report_blu_details[detailKey].details.splice(formulaKey, 1)
            },
            addNewPart(key) {
                this.items[key].template_report_blu_details.push({
                    key: Math.random(10),
                    target_indicator_id: null,
                    order: null,
                    details: [
                        {
                            key: Math.random(10),
                            template_form_data_detail_id: null,
                            score: null,
                            indicator_id: null,
                            parent_id: null,
                            order: null,
                            result_value_formula: null,
                            report_indicator_labels: []
                        }
                    ]
                })
                setTimeout(() => {
                    this.loadTargetIndicators()
                    this.loadIndicators()
                }, 300)
            },
            addNewPartDetail(key, detailKey) {
                this.items[key]
                    .template_report_blu_details[detailKey]
                    .details.push({
                        key: Math.random(10),
                        template_form_data_detail_id: null,
                        indicator_id: null,
                        parent_id: null,
                        order: null,
                        result_value_formula: null,
                        report_indicator_labels: []
                    })
                setTimeout(() => {
                    this.loadIndicators()
                }, 300)
            },
            addNew() {
                this.items.push({
                    key: Math.random(10),
                    name: null,
                    score: null,
                    order: null,
                    template_report_blu_details: [
                        {
                            key: Math.random(10),
                            target_indicator_id: null,
                            order: null,
                            details: [
                                {
                                    key: Math.random(10),
                                    template_form_data_detail_id: null,
                                    score: null,
                                    indicator_id: null,
                                    parent_id: null,
                                    order: null,
                                    result_value_formula: null,
                                    report_indicator_labels: []
                                }
                            ]
                        }
                    ]
                })
                setTimeout(() => {
                    this.loadTargetIndicators()
                    this.loadIndicators()
                }, 300)
            },
            loadTargetIndicators() {
                $('.target-indicator').select2({
                    placeholder: '-- Pilih salah satu --',
                    width: 'resolve',
                    ajax: {
                        url: '/ajax/dropdown-target-indicators',
                        dataType: "json",
                        type: "GET",
                        data: function (params) {
                            return {
                                search: params.term
                            }
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                })
            },
            loadIndicators() {
                const app = this
                $('.indicator').select2({
                    placeholder: '-- Pilih salah satu --',
                    width: 'resolve',
                    ajax: {
                        url: '/ajax/dropdown-indicators-from-template',
                        dataType: "json",
                        type: "GET",
                        data: function (params) {
                            return {
                                search: params.term,
                                year: app.year
                            }
                        },
                        processResults: function (data, page) {
                            return {
                                results: data
                            };
                        }
                    }
                })
            },
            onSelectIndicator(key, detailKey, formulaKey, val) {
                this.items[key].template_report_blu_details[detailKey].details[formulaKey].template_form_data_detail_id = val
                const params = {
                    year:this.year,
                    template_form_data_detail_id: val
                }
                axios.get('/ajax/get-template-indicator-labels', {
                    params
                }).then(({ data }) => {
                    const respData = data.data
                    this.items[key]
                        .template_report_blu_details[detailKey]
                        .details[formulaKey]
                        .indicator_id = respData.indicator_id
                    this.items[key]
                        .template_report_blu_details[detailKey]
                        .details[formulaKey]
                        .report_indicator_labels = respData.report_indicator_labels
                })
            }
        }
    }
</script>
